import { Injectable } from '@angular/core';
import { MedicalConditionsVaccinesModel } from '../../../models/master-data/medical-conditions-vaccines.model';
import { MasterDataUrl } from '../../../shared/urls/master-data.urls';
import { BaseService } from '../../../shared/services/base.service';
import { MedicalConditionCategoryUrl } from '../../../shared/urls/master-data.medical-condition-category.urls';
import { MedicalConditionUrl } from '../../../shared/urls/master-data.medical-condition.urls';

@Injectable()
export class MedicalConditionsVaccinesService {
    constructor(public baseService: BaseService) {

    }

    getMedicalCondition(){
        const urlMedicalCondition = MedicalConditionUrl.MEDICALCONDITION;
        return this.baseService.getData(urlMedicalCondition);
    }
    getVaccinesList(){
        const urlGetAllVaccine = MasterDataUrl.GET_VACCINES;
        return this.baseService.getData(urlGetAllVaccine);
    }

    addNewMedicalConditionVaccine(param){
        const url = MasterDataUrl.ADD_MEDICAL_CONDITION_VACCINE;
        return this.baseService.postData(url, param);
    }

    deleteMedicalConditionVaccine(medicalConditionId,vaccineId) {
        const url = MasterDataUrl.REMOVE_MEDICAL_CONDITION_VACCINE.replace('{medicalConditionId}/{vaccineId}', medicalConditionId + '/' +vaccineId);
        return this.baseService.delete(url);
    }

    getVaccineByMedicalCondition(param){
        let urlMedical = MasterDataUrl.GET_VACCINE_BY_MEDICALCONDITION;
        return this.baseService.getData(urlMedical, param);
    }

}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/medical-conditions-vaccines/medical-conditions-vaccines.service.ts